import { flexRender, Table } from '@tanstack/react-table';
import { Palette } from '@util';
import styled from 'styled-components';

type MobileLayoutProps<TData> = {
  table: Table<TData>;
  colors: Palette;
};

function MobileLayout<TData>({ table, colors }: MobileLayoutProps<TData>) {
  return (
    <StyledWrapper>
      {table.getRowModel().rows.map((row) => (
        <StyledRecordTable key={row.id} colors={colors}>
          <tbody>
            {row.getAllCells().map((cell) => (
              <tr key={cell.id}>
                <StyledMobileHeader as="th">
                  {cell.column.columnDef.header as string}
                </StyledMobileHeader>
                <StyledMobileCell>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </StyledMobileCell>
              </tr>
            ))}
          </tbody>
        </StyledRecordTable>
      ))}
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StyledRecordTable = styled.table<{
  colors: Palette;
}>`
  width: 100%;
  border: 1px solid ${(props) => props.colors.border};
  overflow: hidden;
  margin-bottom: 8px;
  table-layout: fixed;
  color: ${(props) => props.colors.text};

  th,
  td {
    padding: 8px 12px;
    border-bottom: 1px solid ${(props) => props.colors.borderHover};
  }

  th {
    text-align: left;
    background-color: ${(props) => props.colors.layoutOverlayBg};
    font-weight: bold;
  }

  td {
    text-align: left;
    background-color: ${(props) => props.colors.layoutBg};
  }

  tr:last-child * {
    border-bottom: none;
  }
`;

const StyledMobileHeader = styled.th`
  width: 20%;
  vertical-align: top;
`;

const StyledMobileCell = styled.td`
  width: 60%;
  text-align: left;
`;

export default MobileLayout;
